import { createSelector } from 'reselect';
import { getState } from './state';

const empty = [];

export const getDraftSlice = createSelector([getState], slice => {
  return slice.drafts;
});

export const getAllDraftMessages = createSelector(getDraftSlice, state => {
  return state?.messages ?? undefined;
});

export const getDraftMessage = createSelector(
  getDraftSlice,
  (state, room_id) => room_id,
  (state, room_id) => {
    return state.messages[room_id];
  }
);

export const getDraftMessageAttachments = createSelector(
  getDraftSlice,
  (state, room_id) => room_id,
  (state, room_id) => {
    return state.messages[room_id]?.attachments ?? empty;
  }
);

export const getDraftParticipants = createSelector(getDraftSlice, state => {
  return state?.participants ?? empty;
});

export const getDeviationsNotFound = createSelector(getDraftSlice, state => {
  return state?.deviationsNotFound ?? empty;
});

export const getUnfurlLogForRoom = createSelector(
  getDraftSlice,
  (state, room_id) => room_id,
  (state, room_id) => {
    return state?.unfurlLog[room_id] ?? empty;
  }
);

export const getIsUnfurlResolving = createSelector(getDraftSlice, state => {
  return state?.unfurlResolving;
});

export const isMessageAllowed = createSelector(
  getDraftSlice,
  (state, room_id) => room_id,
  (state, room_id) => {
    return state.messages[room_id]?.isMessageAllowed ?? true;
  }
);
